// import TemplateEditor from "./TemplateEditor";

export default store => {
  return {
    path: "templateEditor",
    getComponent(nextState, cb) {
      // require.ensure([],require => {
      const comp = require("./TemplateEditor").default;
      cb(null, comp);
      // },"administrator-tooling");
    },
  };
};
